module.exports = __webpack_public_path__ + "img/num-2.9acd0461.svg";